import {shopLabel, shopOf} from '../../common/stockScope'
import {FC, useEffect, useReducer, useState} from 'react'
import InputField from '../components/InputField'
import {fieldReducer, IProductProps, productActionType, productInitialState} from '../cors/reducers'
import { ISelectOptions } from '../cors/_models'
import { getTax } from '../cors/_requests'
import SharedData from '../../common/SharedData'
import { useIntl } from 'react-intl'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { tenantTaxEnabled } from '../../../tenant/tenantState'

const ProductPriceTab: FC<IProductProps> = ({prodState, prodDispatch, isChecked}) => {
  const {formatMessage} = useIntl()

  // A package's price and quantity come from its components, so both fields are
  // locked. The reason is shown on HOVER rather than as a hint beside the label:
  // the label row is tight (and tighter in Arabic), and a sentence there pushed
  // the fields out of line. Same tooltip component the products list uses.
  const lockedForPackage = (field: string, control: JSX.Element) =>
    prodState.isPackage ? (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`pkg-${field}`}>
            {formatMessage({id: 'package_fields_are_derived'})}
          </Tooltip>
        }
      >
        <span className="d-block" style={{cursor: 'not-allowed'}}>{control}</span>
      </OverlayTrigger>
    ) : (
      control
    )
  const {currentUser,language} = SharedData()
  // A partner shop's account sets its store shelf here, not national supplier stock.
  const shopForLabel = shopOf(currentUser)
  const quantityLabel = shopForLabel
    ? formatMessage({id: 'shop_scope.shelf_at'}, {store: shopLabel(shopForLabel)})
    : formatMessage({id: 'quantity'})
  const [tax, setTax] = useState<ISelectOptions[]>([])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {id, value} = e.target
    prodDispatch({type: productActionType.text, payload: {id, value}})
  }

  useEffect(() => {
    if (!tenantTaxEnabled()) return
    const getTaxData = async () => {
      const {data} = await getTax(currentUser?.token, language);
      const convertData = data.map((item: any) => {
        return {label: item, value: item}
      })

      setTax(convertData)
    }
    getTaxData()
  }, [])

  return (
    <>
      <div className='card default-image-box'>
        <div>
          <div className='d-flex flex-column gap-9'>
            {/* Qunatity  */}
            <div className='w-100'>
              <div className='d-flex gap-10px'>
                <div className={prodState.variations.length === 0 ? 'width-33P' : 'width-100P'}>
                  {tenantTaxEnabled() && (
                    <InputField
                        hasError={prodState.tax_class_id.error}
                        value={prodState.tax_class_id.value}
                        isRequired={true}
                        onChange={handleChange}
                        label={formatMessage({id: 'tax'})}
                        id='tax_class_id'
                        type='select'
                        options={[{label: formatMessage({id: 'tax'}), value: ''}, ...tax]}
                        placeholder={formatMessage({id: 'tax'})}
                    />
                  )}
                </div>
                {prodState.variations.length === 0 &&
                    <div className='width-33P'>
                      {lockedForPackage('quantity',
                        <InputField
                            hasError={prodState.quantity.error}
                            value={prodState.quantity.value}
                            isRequired={true}
                            type='number'
                            onChange={handleChange}
                            id='quantity'
                            min="0"
                            label={quantityLabel}
                            placeholder={quantityLabel}
                            readOnly={prodState.isPackage}
                        />
                      )}
                    </div>
                }

                {/* <div className='col-md-3'>
                  <InputField
                    // hasError={prodState.quantityPerBox}
                    value={prodState.quantityPerBox}
                    isRequired={false}
                    onChange={handleChange}
                    // type='select'
                    type='number'
                    id='quantityPerBox'
                    label={formatMessage({id: 'quantity_per_box'})}
                    min="1"
                    // options={[{label: 'Weight Class', value: ''}]}
                  />
                </div> */}

                {prodState.variations.length === 0 &&
                  <div className='width-33P'>
                    {lockedForPackage('salePrice',
                      <InputField
                          hasError={prodState.salePrice.error}
                          value={prodState.salePrice.value}
                          isRequired={true}
                          onChange={handleChange}
                          type='number'
                          id='salePrice'
                          label={formatMessage({id: 'sale_price'})}
                          errorMsg={prodState.salePrice.msg}
                          placeholder={formatMessage({id: 'sale_price'})}
                          readOnly={prodState.isPackage}
                      />
                    )}
                  </div>
                }
                </div>
              </div>
            </div>

        </div>
      </div>
    </>
  )
}

export default ProductPriceTab
